






















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    "cprod-prov-requests-table": () =>
      import(
        "@/components/app/global/contractProducts/cProdProvRequestsTable.vue"
      )
  }
})
export default class AdminProvisionRequestsLogView extends Vue {
  // Props
  @Prop({ required: false, default: [] })
  public routes!: any[];
  public tableId = "CPRT1";
}
